export default __webpack_public_path__ + "static/pan-499c14474d285ff290e5a386cf04a163.png";